import { render, staticRenderFns } from "./MarketEntry.vue?vue&type=template&id=546cd61a&scoped=true"
import script from "./MarketEntry.vue?vue&type=script&lang=js"
export * from "./MarketEntry.vue?vue&type=script&lang=js"
import style0 from "./MarketEntry.vue?vue&type=style&index=0&id=546cd61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546cd61a",
  null
  
)

export default component.exports